import React, { Component } from "react";
import "./DegreeCard.css";
import { Fade, Flip } from "react-reveal";
import { getHeaderGlassStyle } from "../../utils/glassStyle";

class DegreeCard extends Component {
  render() {
    const degree = this.props.degree;
    const theme = this.props.theme;
    const glassStyle = getHeaderGlassStyle(theme);
    return (
      <div className="degree-card">
        <div className="degree-card-inner" style={{ ...glassStyle, borderRadius: "24px" }}>
          {degree.logo_path && (
            <Flip left duration={2000}>
              <div className="card-img" style={{ ...glassStyle, borderRadius: "12px" }}>
                <img
                  src={require(`../../assests/images/${degree.logo_path}`)}
                  alt={degree.alt_name}
                />
              </div>
            </Flip>
          )}
          <Fade right duration={2000} distance="40px">
            <div className="card-body">
              <div
                className="body-header"
                style={{ backgroundColor: theme.headerColor }}
              >
                <div className="body-header-title">
                  <h2 className="card-title" style={{ color: theme.text }}>
                    {degree.title}
                  </h2>
                  <h3 className="card-subtitle" style={{ color: theme.text }}>
                    {degree.subtitle}
                  </h3>
                </div>
                <div className="body-header-duration">
                  <h3 className="duration" style={{ color: theme.text }}>
                    {degree.duration}
                  </h3>
                </div>
              </div>
              <div className="body-content">
                {degree.descriptions.map((sentence) => {
                  return (
                    <p className="content-list" style={{ color: theme.text }}>
                      {sentence}
                    </p>
                  );
                })}
                {degree.website_link && (
                  <a
                    href={degree.website_link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div
                      className="visit-btn"
                      style={{ backgroundColor: theme.headerColor }}
                    >
                      <p className="btn visit-website-btn">
                        Visit Website
                      </p>
                    </div>
                  </a>
                )}
              </div>
            </div>
          </Fade>
        </div>
      </div>
    );
  }
}

export default DegreeCard;
